export default "__VITE_ASSET__DiiIlcEV__"